'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

export const DataSettingsButton: React.FC = () => {
  const t = useTranslations();

  const showConsentSettings = () => {
    if (
      typeof window !== 'undefined' &&
      window.sprdConsent &&
      typeof window.sprdConsent.showSettings === 'function'
    ) {
      window.sprdConsent.showSettings();
    }
  };

  return (
    <button
      type="button"
      onClick={showConsentSettings}
      className="text-primary hover:text-primary-dark cursor-pointer border-none bg-transparent p-0"
    >
      {t('footer.privacyPolicy.dataSettings')}
    </button>
  );
};
